import {
  DELETE_WORKCOVER_SUCCESS,
    DELETE_WORKCOVER_FAILURE,
} from "../constants/MyM";
  
const initStat = { data: [], error: false, errorData: "", isLoading: true };
  
export default (state = initStat, action) => {
    switch (action.type) {
      case DELETE_WORKCOVER_SUCCESS:
        return {
          ...state,
          data: action.payload,
          isLoading: false,
        };
      case DELETE_WORKCOVER_FAILURE:
        return {
          ...state,
          isLoading: false,
          errorData: action.payload,
          error: true,
        };
      default:
        return { ...state };
    }
};
  